import { useSelector } from 'Modules/core/redux';

import { Progress } from './types';
import { REDUCER_NAME } from './constants';


export const useUploads = (id: Progress['id']): Progress =>
    useSelector(`${REDUCER_NAME}.${id}`);
